import { handleActions } from 'redux-actions';

import { State } from 'features/accessReports/doorBuildingSwipe/redux/types';
import {
  FETCH_DOOR_BUILDING_SWIPE_SEARCH,
  FETCH_DOOR_BUILDING_SWIPE_SEARCH_SUCCESS,
  FETCH_DOOR_BUILDING_SWIPE_SEARCH_FAIL,
  FETCH_DOOR_BUILDING_SWIPE_CONTROLLER,
  FETCH_DOOR_BUILDING_SWIPE_CONTROLLER_SUCCESS,
  FETCH_DOOR_BUILDING_SWIPE_CONTROLLER_FAIL,
  FETCH_DOOR_BUILDING_SWIPE_PARTITIONS,
  FETCH_DOOR_BUILDING_SWIPE_PARTITIONS_SUCCESS,
  FETCH_DOOR_BUILDING_SWIPE_PARTITIONS_FAIL,
  FETCH_DOOR_BUILDING_SWIPE_READERS,
  FETCH_DOOR_BUILDING_SWIPE_READERS_SUCCESS,
  FETCH_DOOR_BUILDING_SWIPE_READERS_FAIL,
  GET_DOOR_BUILDING_SWIPE_SELECTED_DATA,
} from 'features/accessReports/doorBuildingSwipe/redux/constants';

const initialState: State = {
  loading: false,
  loaded: false,
  error: null,
  controllerList: [],
  partitionList: [],
  readerList: [],
  searchList: [],
  selectedParams: {},
  totalPages: 1,
  totalElements: 0,
  numberPage: 1,
  pageSize: 20,
  isVisibleTable: false,
};

export const reducer = handleActions<State, any>(
  {
    [FETCH_DOOR_BUILDING_SWIPE_CONTROLLER]: state => ({
      ...state,
      loading: true,
      loaded: false,
    }),

    [FETCH_DOOR_BUILDING_SWIPE_CONTROLLER_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      controllerList: action.payload.result,
      error: null,
    }),

    [FETCH_DOOR_BUILDING_SWIPE_CONTROLLER_FAIL]: (state, action) => ({
      ...state,
      loading: false,
      loaded: false,
      controllerList: [],
      error: action.payload.message,
    }),
    [FETCH_DOOR_BUILDING_SWIPE_PARTITIONS]: state => ({
      ...state,
      loading: true,
      loaded: false,
    }),

    [FETCH_DOOR_BUILDING_SWIPE_PARTITIONS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      partitionList: action.payload.content,
      pageSize: action.payload.pageable.pageSize,
      error: null,
    }),

    [FETCH_DOOR_BUILDING_SWIPE_PARTITIONS_FAIL]: (state, action) => ({
      ...state,
      loading: false,
      loaded: false,
      partitionList: [],
      pageSize: 20,
      error: action.payload.message,
    }),
    [FETCH_DOOR_BUILDING_SWIPE_READERS]: state => ({
      ...state,
      loading: true,
      loaded: false,
    }),

    [FETCH_DOOR_BUILDING_SWIPE_READERS_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      readerList: action.payload.content,
      pageSize: action.payload.pageable.pageSize,
      error: null,
    }),

    [FETCH_DOOR_BUILDING_SWIPE_READERS_FAIL]: (state, action) => ({
      ...state,
      loading: false,
      loaded: false,
      readerList: [],
      pageSize: 20,
      error: action.payload.message,
    }),
    [FETCH_DOOR_BUILDING_SWIPE_SEARCH]: state => ({
      ...state,
      loading: true,
      loaded: false,
      isVisibleTable: true,
      numberPage: 1,
    }),

    [FETCH_DOOR_BUILDING_SWIPE_SEARCH_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      loaded: true,
      searchList: action.payload.content,
      pageSize: action.payload.pageable.pageSize,
      totalPages: action.payload.totalPages,
      totalElements: action.payload.totalElements,
      numberPage: action.payload.number,
      error: null,
    }),

    [FETCH_DOOR_BUILDING_SWIPE_SEARCH_FAIL]: (state, action) => ({
      ...state,
      loading: false,
      loaded: false,
      isVisibleTable: false,
      searchList: [],
      pageSize: 20,
      totalPages: 1,
      numberPage: 1,
      totalElements: 0,
      error: action.payload.message,
    }),
    [GET_DOOR_BUILDING_SWIPE_SELECTED_DATA]: (state, action) => ({
      ...state,
      selectedParams: action.payload,
    }),
  },
  initialState
);

export default reducer;
